<template>
	<div class="bookPinglunBox">
		<!-- 书单评论 -->
		<div class="bookPinglun">
			<!-- 头部 -->
			<van-sticky>
				<div class="headerBox">
					<div class="headerQuery">
						<!-- jumpbookdyinfo -->
						<div class="arrImg" @click="$router.back(-1)">
							<img src="../../assets/img/leftarr_tit.png" alt="">
						</div>
						<p class="header_titile">书单评论</p>
						<div class="header_qk" @click="showToast()">
							<img src="../../assets/img/share.png" alt="">
						</div>
					</div>
				</div>
			</van-sticky>
			<div class="pinglunList" v-if="list_comment.length != 0 ? true : false"  :style="'height:'+ pinglunListH +'px'">
				<div class="pinglun_box" v-for="(item,index) in list_comment" :key='index'
				 @touchstart="showDeleteButton(item.id)" @touchend="emptyTime">
					<div class="pinglun_top">
						<div class="pinglun_user">
							<img :src="$api.$BASE_URL_img +item.avatar" alt="">
							<div>
								<span class="wname">{{item.nickname}}</span>
								<p class="timedata">{{formatDateTime(item.createtime)}}</p>
							</div>
						</div>
						<!-- <p class="bookName">《{{item.c_name}}》</p> -->
					</div>

					<div class="pinglun_bottom">
						<p class="pinglun_middle">{{item.c_content}} </p>
						<div class="reply_img" @click="toReply(item.id,item.user_id,item.nickname,item.c_content)">
							<img src="../../assets/img/xiaoxi.png" alt="">
						</div>
					</div>
					<div class="er_reply" 
						 v-if="item.child.length">
						<div :class="!item.show_comment ? 'list_item threelist' : 'list_item'" v-for='(it,index1) in item.child' :key='it.id'>
							<p class="top_text">
								<span class="name">{{it.reply_nickname}}</span>
								<span class="floor">{{index1+1}}楼</span>
							</p>
							<p class="content">{{it.c_content}}</p>
							<p class="time"><span class="er_reply_time">{{formatDateTime(it.createtime)}}</span></p>
						</div>
			
					</div>
					<div v-if="item.child.length > 3"  @click="showComment(index)" class="more_comment" >
						<span>
							 {{!item.show_comment ? '更多评论' : '收起评论'}}
						</span>
						<img src="../../assets/img/rightArrs.png" alt="">
					</div>
				</div>
			</div>
			<div v-if="list_comment.length == 0 ? true : false" class="data_null">
				<img src="../../assets/img/data_null.png" alt="">
			</div>
			<!-- 2020.08.17注释 -->
			<!-- <div v-if="list_comment.length == 0 ? true : false" class="data_null">
				<img src="../../assets/img/data_null.png" alt="">
			</div>
			<div class="comment_input" @click="tostShow">
				<div class="input_hf">
					<input type="text" placeholder="说点啥" />
					<img src="../../assets/img/sdadd.png" alt="">
				</div>
				<span>发送</span>
			</div> -->
		</div>
		<!-- 回复框 -->
		<div class="reply">
			<!-- <div class="replay_people">
				<p class="people_name"><span v-html="nickname"></span>:<span v-html="c_content"> </span></p>
				<div class="zan_img">
					<img src='../../assets/img/zan.png' />
				</div>
			</div>
			<div class="replay_inner">
				<div class="replay_text"><input ref="replyValue" :placeholder="change_text" /></div>
				<div class="replay_right">
					<div class="zan_box">
						<img src='../../assets/img/ok.png' />
					</div>
					<div class="go_box" @click="goReply">
						<img src='../../assets/img/go.png' />
					</div>
				</div>
			</div> -->
			<div class="comment_input">
				<div class="input_hf">
					<input type="text" ref="replyValue" :placeholder="change_text" />
					<!-- <img src="../../assets/img/sdadd.png" alt=""> -->
				</div>
				<span @click="goReply">发送</span>
			</div>
		</div>
		
		<!-- 弹窗 -->
		<div class="tostBoxFather" v-show="tostShowBox">
			<div class="header_img">
				<img src="../../assets/img/pltost.png" alt="" />
			</div>
			<!-- <div class="dog_img">
				<img src="../../assets/img/dog.png" alt="" />
			</div> -->
			<div class="tostBoxson">
				<div class="yunjinbiBox">
					<div class="yunjinbi" :class="itemyunjinbi == index ? 'active': ''"
					v-for="(item, index) in yunjinbiList" :key="index"
					v-if="index <= 6 ? true : false"
					 @click="itemyunjinbiFn(index,item.txt)">
						<div class="yunjinbi_left">
							<img :src="item.imgUrl" alt="">
						</div>
						<div class="yunjinbi_right">
							<span>{{item.txt}}</span></br><span>{{item.jinbi}}</span>
						</div>
					</div>
					<div class="yunjinbi" :class="itemyunjinbi == index ? 'active': ''" 
					v-for="(item, index) in yunjinbiList" :key="index"
					v-if="index > 6 ? true : false"
					 @click="itemyunjinbiFn(index,item.txt)">
						<div class="yunjinbi_left">
							<img :src="item.imgUrl" alt="">
						</div>
						<div class="yunjinbi_right">
							<span>{{item.txt}}</span></br><span>{{item.jinbi}}</span>
						</div>
					</div>
				</div>
				<div class="selecttost">
					<div><span class="autherName">{{userInfo.username}}</span> <span @click="toggle" class="seleValue"><i v-model="queryTitle">{{queryTitle}}</i><img
							 src="../../assets/img/downarr.png" alt=""></span></div>
					<ul v-show="selectItem" class="select_item">
						<li v-for="(item,index) in selectItemList" @click="query_select(item.id,item.txt)" :class="queryIndex == item.id ? 'activeQuery' : ''">
							<span>{{item.txt}}</span>
							<span class="queryArr" v-if="queryIndex == item.id ? true : false"><img src="../../assets/img/query.png" alt=""></span>
						</li>
					</ul>
				</div>
				<div class="tost_say">
					<textarea ref="getValue" placeholder="说点啥..."></textarea>
					<!-- <img src="../../assets/img/smile.png" alt="" class="smileImg" /> -->
				</div>
				<div class="submitBox">
					<img src="../../assets/img/flower.png" alt="" class="flower">
					<button @click="jumpUrl">提交</button>
				</div>
			</div>
		</div>
		<div class="mask" @click="onMask" v-show="tostShowBox"></div>
		
		<!-- 投诉弹框 -->
		<div class="luntantost" v-show="tostShowBoxTS  == true">
			<div class="luntantostbgc">
				<div @click.stop="forumSetFn" class="active">投诉</div>
		
			</div>
		</div>
		<div class='mask' v-show="tostShowBoxTS == true" @click="hideTost"></div>
	</div>
</template>

<script>
	import qs from 'qs';
	import {Toast} from'vant'
	export default {
		data() {
			return {
				tousuId: '',
				tostShowBoxTS: false,
				queryIndex: 0, //排序选择
				queryTitle: '评分',
				selectItem: false,
				itemShow: false,
				tostShowBox: false, //弹框
				showReply: false, //回复框
				itemyunjinbi: null, //弹框 云锦币
				selectItemList: [{
						id: -2,
						txt: '-2分',
					},
					{
						id: -1,
						txt: '-1分',
					},
					{
						id: 0,
						txt: '0分',
					},
					{
						id: 1,
						txt: '1分',
					},
					{
						id: 2,
						txt: '2分',
					},
				],
				yunjinbiList: [{
						txt: '流星',
						jinbi: '100云锦币',
						imgUrl: require('../../assets/img/ds01.png')
					},
					{
						txt: '卫星',
						jinbi: '500云锦币',
						imgUrl: require('../../assets/img/ds02.png')
					},
					{
						txt: '行星',
						jinbi: '1000云锦币',
						imgUrl: require('../../assets/img/ds03.png')
					},
					{
						txt: '恒星',
						jinbi: '2000云锦币',
						imgUrl: require('../../assets/img/ds04.png')
					},
					{
						txt: '彗星',
						jinbi: '5000云锦币',
						imgUrl: require('../../assets/img/ds05.png')
					},
					{
						txt: 'M78星云',
						jinbi: '10000云锦币',
						imgUrl: require('../../assets/img/ds06.png')
					},
					{
						txt: '银河系',
						jinbi: '100000云锦币',
						imgUrl: require('../../assets/img/ds07.png')
					},
					{
						txt: '琼浆玉露',
						jinbi: '20琼浆玉露',
						imgUrl: require('../../assets/img/ds08.png')
					},
					{
						txt: '琼浆玉露',
						jinbi: '60琼浆玉露',
						imgUrl: require('../../assets/img/ds08.png')
					}
				],
				list_comment: [],
				userInfo: {},
				List_id: '',
				pid: '',
				reply_id: '',
				content: '',
				theme: '',
				c_score: '-2分',
				nickname: '',
				c_content: '',
				flag: true, //查看更多
				itemyunjintxt:'',//云锦币icon
				change_text: '评论TA...',
				pinglunListH:812,
			}
		},
		created() {
			this.pinglunListH = document.documentElement.clientHeight-160;
			console.log(this.pinglunListH,'pinglunListH')
			this.List_id = this.$route.query.list_id
			this.get_list_comment()
		},
		mounted() {
			this.userInfo = JSON.parse(window.localStorage.getItem('userInfo'))
		},
		methods: {
			// 评论投诉接口
			forumSetFn() {
				if(this.tousuId != ''){
					this.$axios.post(this.$api.tousu,{
						id: this.tousuId,
					}).then(res =>{
						Toast(res.data.msg);
						this.tostShowBoxTS = false;
					})
				}
			},
			hideTost(){
				this.tostShowBoxTS = false;
			},
			showDeleteButton(id) {
				// this.show_ldBox = false;
				this.tousuId = id;
				clearTimeout(this.Loop); //再次清空定时器，防止重复注册定时器
				this.Loop = setTimeout(function() {
					this.tostShowBoxTS = true;
				}.bind(this), 1000);
			},
			emptyTime() {
				clearTimeout(this.Loop); //清空定时器，防止重复注册定时器
			},
			// 弹窗点击提交
			jumpUrl() {
				if (this.$refs.getValue.value) {
					this.content = this.$refs.getValue.value
					// this.tostShowBox = !this.tostShowBox;
					this.tostShowBox = false;
					// this.$axios.post(this.$api.add_comment_index,{
					// 	book_id: this.List_id,
					// 	gift: this.itemyunjinbi,
					// 	coin: this.itemyunjintxt,
					// 	content: this.content,
					// 	score: this.queryIndex,
					// }).then(res =>{
					// 	console.log(res)
					// })
					this.add_comment()
					this.$refs.getValue.value = ''
				} else {
					console.log('请输入评论内容')
				}

			},
			jumpbookdyinfo() {
				// this.$router.push('/bookdyinfo')
				window.history.go(-1)
			},
			toggle() {
				this.selectItem = !this.selectItem
			},
			tostShow() {
				// this.tostShowBox = !this.tostShowBox
				this.tostShowBox =false;
			},
			onMask() {
				// this.tostShowBox = !this.tostShowBox
				this.tostShowBox =false;
			},
			query_select(index, txt) {
				console.log(index)
				this.c_score = txt
				this.queryIndex = index
				this.queryTitle = txt
				this.selectItem = !this.selectItem
			},
			itemyunjinbiFn(data,txt) {
				this.itemyunjinbi = data;
				this.itemyunjintxt=txt;
			},
			// 回复
			toReply(id, user_id, nickname, c_content) {
				this.change_text = '回复'+ nickname;
				this.pid = id
				this.reply_id = user_id
				this.nickname = nickname
				this.c_content = c_content
				// this.showReply = !this.showReply
			},
			goReply() {
				if(JSON.parse(localStorage.getItem('userInfoData')) != null){
					if (this.$refs.replyValue.value) {
						this.content = this.$refs.replyValue.value
						this.showReply = !this.showReply
						this.add_comment()
						this.$refs.replyValue.value = ''
					} else {
						this.showReply = !this.showReply
					}
				}else{
					Toast('请登录后操作')
				}
				
			},
			get_list_comment() {
				this.$axios.post(`${this.$api.list_comment}?list_id=${this.List_id}`).then(res => {
					console.log(res)
					if (res.status == 200) {
						if (res.data.data.length != 0) {
							this.list_comment = res.data.data
						}
					}

				})
			},

			add_comment() {
				let comment = {
					list_id: this.List_id,
					pid: this.pid,
					reply_id: this.reply_id,
					content: this.content,
					theme: this.theme,
					c_score: this.c_score,
					gift: this.itemyunjinbi ? 1 : 0,
					coin: this.itemyunjintxt,
				}
				// this.$axios.post(this.$api.add_comment_index + '?' + qs.stringify(comment)).then(res => {
				// 	this.get_list_comment()
				// 	console.log(res)
				// })
				this.$axios.post(this.$api.add_comment_index,comment).then(res =>{
					Toast(res.data.msg)
					this.get_list_comment();
				})
			},
			showComment(index) {
			    // 因为vue的机制，在渲染玩完成后新添加的数据要用$set
			    if (!this.list_comment[index].show_comment) {
			        this.$set(this.list_comment[index], 'show_comment', true);
			    } else {
			        // 当有了数据就用正常的取反就行了
			        this.list_comment[index].show_comment = !this.list_comment[index].show_comment;
			    }
			},
			formatDateTime(dateNum) {
				var date = new Date(dateNum * 1000);
				return date.getFullYear() + "-" + fixZero(date.getMonth() + 1, 2) + "-" + fixZero(date.getDate(), 2) + " " +
					fixZero(date.getHours(), 2) + ":" + fixZero(date.getMinutes(), 2) + ":" + fixZero(date.getSeconds(), 2);
			
				function fixZero(num, length) {
					var str = "" + num;
					var len = str.length;
					var s = "";
					for (var i = length; i-- > len;) {
						s += "0";
					}
					return s + str;
				}
			},
			showToast() {
				this.$toast('该功能暂未开通');
			}
		}
	}
</script>

<style lang="less" scoped>
	.mask {
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		overflow: hidden;
		z-index: 999;
		background-color: rgba(0, 0, 0, .4);
	}
	// 书本评论投诉
		//弹窗
		.luntantost {
			position: fixed;
			bottom: 0;
			left: 0;
			width: 100vw;
			// height: 454px;
			background: url(../../assets/img/pltost.png) no-repeat;
			background-size: 100%;
			z-index: 99999;
		
			img {
				position: absolute;
				bottom: 40px;
				left: 0;
				width: 100%;
			}
		
			.luntantostbgc {
				margin-top: 124px;
				z-index: 10000 !important;
				background: url(../../assets/img/dog.png) no-repeat #fff;
				background-size: 70%;
				background-position: 60% 80%;
		
				div {
					line-height: 120px;
					text-align: center;
					color: #737373;
					font-size: 30px;
					/*px*/
					z-index: 1000 !important;
				}
		
				div.active {
					color: #ff4081;
				}
		
			}
		
		}
	.bookPinglunBox {
		height: 100vh;
		background-color: #fff;
		overflow: hidden;

		.bookPinglun {

			// 头部
			.headerBox {
				height: 160px;
				// background-color: #ff4081;
				display: flex;
				background: url(../../assets/img/myicon/indexBgc03.png) no-repeat 0% 88%;
				background-size: 100%;
				background-color: #ffffff;
				border-bottom: 1px solid #f0f0f0;/*no*/
				.headerQuery {
					margin-top: 80px;
					padding: 0 16px;
					position: relative;
					display: flex;
					width: 100%;
					height: 80px;
					line-height: 80px;
					color: #000;

					.arrImg {
						img {
							width: 50px;
							position: absolute;
							top: 50%;
							transform: translateY(-50%);
							left: 0px;
						}
					}

					.header_titile {
						flex: 1;
						text-align: center;
						font-size: 34px;
						/*px*/
					}

					.header_qk {
						img {
							position: absolute;
							top: 50%;
							right: 16px;
							transform: translateY(-50%);
							width: 60px;
							height: 60px;
						}
					}
				}

			}

			.pinglunList {
				background-color: #fff;
				padding: 0px 16px;
				padding-bottom: 140px;
				overflow-y: auto;
			}
			.data_null{
				text-align: center;
				img{
					width: 160px;
					margin-top: 30%;
				}
			}
			.pinglun_box:last-of-type {
				border-bottom: 0;
			}

			.pinglun_box {
				background-color: #fff;
				padding: 24px 0px;
				padding-bottom: 5px;
				border-bottom: 1px solid #f0f0f0;

				/*no*/
				.pinglun_top {
					display: flex;
					// padding-bottom: 24px;
					// padding: 24px 0;
					.pinglun_user {
						flex: 1;
						overflow: hidden;

						img {
							width: 80px;
							height: 80px;
							display: block;
							float: left;
							border-radius: 50%;
							border: 2px solid #f0f0f0;/*no*/
						}

						div {
							float: left;
							padding-left: 24px;

							.wname {
								display: inline-block;
								color: #3d3d3d;
								font-size: 30px;
								/*px*/
								width: 260px;
								height: 40px;
								white-space: nowrap;
								text-overflow: ellipsis;
								overflow: hidden;
							}

							.timedata {
								color: #7f7f7f;
							}

							p {
								padding-top: 10px;
							}
						}
					}

					.bookName {
						color: #737373;
						font-size: 28px;
						/*px*/
						width: 260px;
						height: 40px;
						white-space: nowrap;
						text-overflow: ellipsis;
						overflow: hidden;
					}
				}

				.pinglun_bottom {
					color: #a3a3a3;
					display: flex;
					justify-content: space-between;
					position: relative;

					.pinglun_middle {
						color: #3d3d3d;
						line-height: 50px;
						width: 90vw;
						font-size: 30px;/*px*/
					}

					.reply_img {
						width: 40px;
						height: 40px;

					}

					img {
						width: 100%;
					}
				}

				.er_reply {
					color: #767676;
					padding: 10px 30px;
					border-radius: 4px;
					.list_item {
						line-height: 50px;
						padding:0 30px;
						box-sizing: border-box;
						border-bottom: 1px solid #fff;
						background-color: #f0f0f0;
						
						.top_text{
							width:100%;
							display: flex;
							flex-direction: row;
							justify-content: space-between;
							
							.name{
								color: #3d3d3d;
							}
							
							.floor{
								color: #ff4081;
							}
						}
						
						.content{
							overflow: hidden;
							width:100%;
							max-height:95px;
						}
						
						.time{
							width:100%;
							display: flex;
							justify-content: flex-end;
							
							
							.er_reply_time {
								font-size: 24px;
								/*px*/
								color: #848484;
								margin-left: 20px;
							}
						}
					}
					
					.list_item:last-child{
						border-bottom: 0;
					}
					
					.threelist{
						display: none;
					}
					.threelist:nth-child(1){
						display: block;
					}
					.threelist:nth-child(2){
						display: block;
					}
					.threelist:nth-child(3){
						display: block;
					}
				}
				.fix_height {
				    height: 460px;
				    overflow: hidden;
				    text-overflow: ellipsis;
					box-sizing: border-box;
				}
				.more_comment{
					padding: 14px 10px;
					color:#666666;
					text-align: center;
					display: flex;
					flex-direction: row;
					justify-content: center;
					align-items: center;
					color: #ff4081;
					
					img{
						width:25px;
						margin-left:10px;
					}
				}
			}

		}

		// 回复框
		.reply {
			box-sizing: border-box;
			background-color: #fff;
			position: absolute;
			bottom: 0;
			left: 0;
			width: 100%;

			.comment_input{
				width: 100vw;
				height: 80px;
				padding: 20px 0;
				background-color: #fff;
				border-top: 1px solid #f0f0f0;
				
				/*no*/
				.input_hf {
					position: absolute;
					top: 50%;
					transform: translateY(-50%);
					width: 80%;
					margin-left: 16px;
					height: 80px;
					line-height: 80px;
					border-radius: 80px;
					position: relative;
					border: 1px solid #fa7298;
				
					/*no*/
					input {
						width: 92%;
						background-color: transparent;
						padding-left: 20px;
						border-radius: 80px;
					}
				
					img {
						position: absolute;
						top: 50%;
						right: 20px;
						transform: translateY(-50%);
						width: 50px;
					}
				}
				
				span {
					text-align: center;
					position: absolute;
					top: 50%;
					right: 10px;
					transform: translateY(-50%);
					background-color: #fa7298;
					color: #fff;
					padding: 15px 30px;
					border-radius: 20px;
				}
			}
		}

		// 弹窗
		.tostBoxFather {
			z-index: 1000;
			position: fixed;
			bottom: 0;
			left: 0;
			height: 1100px;
			width: 100vw;
			overflow: hidden;

			.header_img {
				position: absolute;
				top: 4px;
				left: 0;

				img {
					width: 100vw;
				}
			}

			// .dog_img{
			// 	img {
			// 		width: 80%;
			// 		position: absolute;
			// 		top: 30%;
			// 		left: 50%;
			// 		transform: translateX(-50%);
			// 		z-index:100;
			// 	}
			// }
			.tostBoxson {
				position: absolute;
				top: 128px;
				left: 0;
				background-color: #fff;

				// 云锦币
				.yunjinbiBox {
					overflow: hidden;
					padding: 20px 16px;
					padding-bottom: 0;
					height: 540px;
					background: url(../../assets/img/dog.png) no-repeat center;
					background-size: 85%;
					background-position: 99% 100%;

					.yunjinbi {
						width: calc((100vw - 88px) / 3);
						box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, .3);
						/*no*/
						border: 1px solid #fa7298;
						/*no*/
						padding: 20px 0px;
						text-align: left;
						margin-right: 20px;
						border-radius: 10px;
						float: left;
						margin-bottom: 20px;
						color: #3d3d3d;
						position: relative;
						height: 120px;
						.yunjinbi_left {
							img {
								width: 100px;
								position: absolute;
								top: 30%;
								left: 50%;
								transform: translate(-50%,-50%);
							}
						}

						.yunjinbi_right {
							// padding-left: 100px;
							padding-top: 55px;
							text-align: center;
						}
					}

					.yunjinbi.active {
						box-shadow: none;
						background-color: #fff8fa;

						color: #000000;
					}

					.yunjinbi:nth-child(3n) {
						margin-right: 0;
					}
				}

				.selecttost {
					background-color: #fff;
					position: relative;
					height: 80px;
					line-height: 80px;
					padding: 0 16px;
					border-bottom: 1px solid #f0f0f0;
					/*no*/
					font-size: 30px;

					div {
						width:100%;
						display: flex;
						justify-content: space-between;
						
						.autherName {
							padding-right: 40px;
							font-weight: 600;
							color: #ff4081;
						}

						.seleValue {
							i {
								font-style: normal;
							}

							img {
								padding-left: 10px;
								width: 20px;
							}
						}
					}

					// 下拉框css
					ul.select_item {
						position: absolute;
						top: 80px;
						right: 2%;
						background-color: #fff;
						z-index: 100;
						border-radius: 5px;
						-webkit-box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, .3);
						/*no*/
						-moz-box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, .3);
						/*no*/
						box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, .3);

						/*no*/
						li {
							width: 200px;
							padding: 0 20px;
							line-height: 60px;
							border-bottom: 1px solid #f0f0f0;
							/*no*/

							span {
								font-size: 28px;
								/*px*/
							}

							img {
								margin-left: 60px;
								width: 20px;
								height: 20px;
							}

							.queryArr {
								padding-left: 20px;
							}
						}

						.activeQuery {
							color: #ff4081;
							border-bottom: 4px solid #f0f0f0;
							/*no*/
						}
					}
				}

				//评论
				.tost_say {
					background-color: transparent;

					height: 160px;
					padding: 0 16px;
					overflow: hidden;
					position: relative;
					border-bottom: 1px solid #f0f0f0;

					/*no*/
					.smileImg {
						position: absolute;
						bottom: 10px;
						right: 16px;

						img {
							width: 40px;
						}
					}

					textarea {
						border: 0;
						height: 190px;
						padding: 20px 0;
						width: calc(100vw - 32px);
						background-color: transparent;
					}

					textarea::placeholder {
						font-size: 26px;
						/*px*/
						color: #3d3d3d;
					}
				}

				//提交
				.submitBox {
					background-color: #fff;
					position: relative;
					text-align: center;
					margin-top: 50px;
					margin-bottom: 40px;

					.flower {
						position: absolute;
						top: -60px;
						left: 20%;
						width: 100px;
					}

					button {
						width: 90%;
						border: 0;
						border-radius: 10px;
						line-height: 80px;
						font-size: 32px;
						/*px*/
						background-color: #FF4081;
						color: #fff;
					}
				}
			}
		}

	}
</style>
